document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('gmv-popup-store');
  if (!popup) return;

  var closeBtn = popup.querySelector('[data-store-popup-close]');
  var STORAGE_KEY = 'gmv_store_popup_dismissed';

  function showPopup() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (e) {}
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hidePopup);
  }

  popup.addEventListener('click', function (e) {
    if (e.target === popup) hidePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.style.display === 'flex') {
      hidePopup();
    }
  });

  var dismissed = false;
  try {
    var ts = localStorage.getItem(STORAGE_KEY);
    if (ts) {
      var daysSince = (Date.now() - parseInt(ts, 10)) / 86400000;
      dismissed = daysSince < 7;
    }
  } catch (e) {}

  var leftPanel = popup.querySelector('.gmv-popup-store__left');
  if (leftPanel) {
    var desktopBg = leftPanel.getAttribute('data-desktop-bg');
    var mobileBg = leftPanel.getAttribute('data-mobile-bg');
    function updateBg() {
      var img = window.innerWidth <= 1024 ? mobileBg : desktopBg;
      if (img) leftPanel.style.backgroundImage = "url('" + img + "')";
    }
    updateBg();
    window.addEventListener('resize', updateBg);
  }

  if (!dismissed) {
    setTimeout(showPopup, 1500);
  }
});
